










































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {DebtPostOffice} from "@/interfaces/entity";
import {ExpensePostOfficeStore} from "@/modules/receiptsexpenses/expensepostoffice/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {SiteTargetType} from "@/enums/type";
import moment from "moment";
import {FORMAT_DATE_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Ngày phát hành",
        dataIndex: "billLading.ladingDate",
        key: "ladingDate",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: "ladingCode"}
    },
    // {
    //   title: "Thu tiền NN",
    //   dataIndex: "billLading.receiverCollect",
    //   key: "receiverCollect",
    //   scopedSlots: {customRender: 'receiverCollect'},
    // },
    {
        title: "Tuyến phát",
        dataIndex: "billLading.deliveryTargetRowGuid",
        key: "deliveryTargetRowGuid",
        scopedSlots: {customRender: 'deliveryTargetRowGuid'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Trạng thái bưu gửi",
        dataIndex: "billLading.status",
        key: "statusBillLading",
        scopedSlots: {customRender: 'statusBillLading'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng trả",
        dataIndex: "money",
        key: "money",
        scopedSlots: {customRender: 'money'},
        width: 120,
        ellipsis: true
    },
    {
        title: "Bưu cục",
        dataIndex: "postOfficeCreditor.name",
        key: "postOfficeName",
        width: 150,
        ellipsis: true
    },
    {
        title: "TT.Thu tiền",
        dataIndex: "billLading.collectDelivery",
        key: "collectDelivery",
        scopedSlots: {customRender: "collectDelivery"},
        width: 120,
        ellipsis: true
    },
    {
        title: "Ngày thu tiền",
        dataIndex: "billLading.payCollectUpdateBy",
        key: "collectDeliveryDate",
        scopedSlots: {customRender: "collectDeliveryDate"},
        width: 150,
        ellipsis: true
    }
];
@Component({
    name: "ExpensePostOfficeTable",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtPostOffices!: Array<DebtPostOffice>;
    columns = columns;
    moment = moment;
    FormatDate = FORMAT_DATE_PICKER;

    SiteTargetType = SiteTargetType;

    get pagination() {
        return {
            current: ExpensePostOfficeStore.meta.page,
            pageSize: ExpensePostOfficeStore.meta.limit,
            total: ExpensePostOfficeStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ExpensePostOfficeStore.updateParamsCreditPostOffice({
            ...ExpensePostOfficeStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ExpensePostOfficeStore.listCreditPostOffice(ExpensePostOfficeStore.params);
    }
}
